import React, { Component } from 'react'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import CalendarContainer from './Containers/CalendarContainer'
import rootReducer from './store/reducers'
import initialState from './store/initialState'
import tooltipsMiddleware from './store/middlewares/tooltips'

const store = createStore(
    rootReducer,
    initialState,
    compose(
        applyMiddleware(tooltipsMiddleware),
        // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
)

export default class CalendarWrapper extends Component {
    render() {
        return (
            <Provider store={store}>
                <CalendarContainer />
            </Provider>
        )
    }
}
